import React from 'react';
import { goPrevious, goToNext, useFieldAutoFocus, useFormValue } from '../common';
import { FormLabel } from "./FormLabel";
import { BlockSelect } from "./BlockSelect.component";
import { Dropdown } from "semantic-ui-react";
import styled from "styled-components";
import { useFluidForm } from "../FormContext";
import "../common-form-styles.css";
import { isNullOrUndefined } from "../../../../shared";
export const OptionsRegion = styled(Dropdown).attrs({ search: true, selection: true }) `
    /* Most styling is now handled by fluid-dropdown and fluid-input classes */
    /* These styles override Semantic UI defaults but work with our dynamic system */
    &.ui.selection.dropdown {
        /* Placeholder text styling */
        &:not(.filtered) > .default.text {
            color: #9ca3af;
        }
        
        /* Style the input element inside */
        & > input.search {
            border: none;
            background: transparent;
            outline: none;
            box-shadow: none;
        }
      
        &:not(.multiple) > input.search {
            padding: 0.7rem 0.625rem;
            line-height: 1.25rem;
        }    
        
        /* Style the dropdown arrow */
        &:before {
            display: none;
        }
        
        & > .dropdown.icon {
            opacity: 0.5;
            color: #6b7280;
        }
    }
    
    /* Style the dropdown menu */
    .menu {
        .item {
            &:hover {
                background: #f3f4f6;
            }
            
            &.active {
                background: #fef3e2;
                color: #ea580c;
                font-weight: 500;
            }
        }
    }
`;
export function FieldOptionsComponent({ fieldPath, options: componentOptions }) {
    const fluidForm = useFluidForm();
    const field = fluidForm.getFieldRenderView(fieldPath);
    const config = fluidForm.getFieldConfigByFieldPath(fieldPath);
    let ref = React.useRef(null);
    let [value, setValue] = useFormValue(fieldPath);
    useFieldAutoFocus(ref, fieldPath, componentOptions?.autoFocus);
    const readOnly = config.readOnly || false;
    const handleKeyDown = (event) => {
        // if (event.key === "Enter") {
        //   event.preventDefault();
        //   //goToNext(field.name!, configService);
        //   return;
        // }
        if (event.key === "Backspace" && event.target.value === "") {
            event.preventDefault();
            goPrevious(fieldPath, fluidForm);
            return;
        }
    };
    let options = config.options || [];
    let optionsList = options.map((option) => ({ key: option.value, text: option.text, value: option.value }));
    let omitLabel = componentOptions?.omitLabel || false;
    if (!isNullOrUndefined(value) && config.type === "multipleOptions" && !Array.isArray(value)) {
        value = value.toString().split(",").map((v) => v.trim());
    }
    const layout = config.styles?.layout || "select";
    // Common props for both components
    const commonProps = {
        'data-fieldname': field.fieldPath,
        clearable: true,
        readOnly: readOnly,
        fluid: true,
        multiple: config.type === "multipleOptions" ? true : false,
        onKeyDown: handleKeyDown,
        onFocus: () => {
            fluidForm.setCurrentField(field.fieldPath);
        },
        onBlur: () => {
            fluidForm.unfocusField(field.fieldPath);
        },
        options: optionsList,
        placeholder: config.type === "multipleOptions" ? "Select Options" : "Select Option",
        value: value,
        onChange: (event, data) => {
            setValue(data.value);
            // Auto-advance on single selection for block layout
            if (layout === "block" && config.type !== "multipleOptions") {
                goToNext(field.fieldPath, fluidForm);
            }
            //goToNext(field.fieldPath, configService);
        }
    };
    return React.createElement("div", { ref: ref },
        !omitLabel && React.createElement(FormLabel, { config: config, options: componentOptions, fieldPath: fieldPath }),
        layout === "select" && React.createElement(OptionsRegion, { search: true, ...commonProps, className: "fluid-dropdown fluid-input" }),
        layout === "block" && React.createElement(BlockSelect, { ...commonProps, variant: "compact", className: " fluid-block-select" }));
}
